import { useEffect } from "react";
import { PublicLayout } from "@/components/layout/PublicLayout";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { LEGAL } from "@/config/legal";

export default function DPAPage() {
  useEffect(() => {
    document.title = "Data Processing Agreement | Decision Sales OS";
  }, []);

  return (
    <PublicLayout showCookieBanner={false}>
      <h1 className="text-3xl font-semibold tracking-tight mb-4">Data Processing Agreement (DPA)</h1>
      <p className="text-muted-foreground mb-8">Last updated: February 2025</p>

      <Card className="mb-6">
        <CardHeader>
          <CardTitle>1. Parties</CardTitle>
        </CardHeader>
        <CardContent className="prose prose-neutral dark:prose-invert max-w-none text-muted-foreground">
          <p>
            This Data Processing Agreement is entered into between the Customer (data controller)
            and {LEGAL.companyName}, {LEGAL.address}, P.IVA/VAT: {LEGAL.pivaVat} (data processor).
          </p>
        </CardContent>
      </Card>

      <Card className="mb-6">
        <CardHeader>
          <CardTitle>2. Scope and processing</CardTitle>
        </CardHeader>
        <CardContent className="prose prose-neutral dark:prose-invert max-w-none text-muted-foreground">
          <p>
            The processor shall process personal data only on documented instructions from the
            controller and in accordance with applicable data protection law (including GDPR where applicable).
          </p>
        </CardContent>
      </Card>

      <Card className="mb-6">
        <CardHeader>
          <CardTitle>3. Security and sub-processors</CardTitle>
        </CardHeader>
        <CardContent className="prose prose-neutral dark:prose-invert max-w-none text-muted-foreground">
          <p>
            The processor shall implement appropriate technical and organisational measures to ensure
            a level of security appropriate to the risk. Sub-processors may be used only with the
            controller&apos;s consent or as set out in our sub-processor list.
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>4. Contact</CardTitle>
        </CardHeader>
        <CardContent className="prose prose-neutral dark:prose-invert max-w-none text-muted-foreground">
          <p>
            Data protection enquiries:{" "}
            <a href={`mailto:${LEGAL.dpoEmail}`} className="text-primary hover:underline">
              {LEGAL.dpoEmail}
            </a>
          </p>
        </CardContent>
      </Card>
    </PublicLayout>
  );
}
